module.exports = __webpack_public_path__ + "img/SDG-05-EN.a93413a8.png";